import "./sentry.js";
import * as Sentry from "@sentry/browser";

require("../resources/gtm.js");
const lottie = require("lottie-web");

document.body.addEventListener("dragstart", (event) => {
  if (event.target && event.target.draggable) {
    // absurdly, this is needed for Firefox; see https://medium.com/elm-shorts/elm-drag-and-drop-game-630205556d2
    event.dataTransfer.setData("text/html", "blank");
  }
});
document.body.addEventListener("dragover", (event) => {
  // this is needed in order to make dragging work
  return false;
});
var CONSTANTS = {
  CONFIG_STORAGE: "configStorage",
  CUSTOMER_SUCCESS: "customerSuccess",
  HAS_INSIGHTS: "hasInsights",
  ZENDESK_TOKEN: "zendeskToken",
  ELM: "elm",
  FEATURES: "features",
  LOTTIE: "lottie",
  MESSAGE_KEY: "message",
  ONBOARD_TOGGLE: "onboardToggle",
  STRING_TYPE: "string",
  TOKEN: "token",
};
var token = localStorage.getItem(CONSTANTS.TOKEN);
var customerSuccess = JSON.parse(
  localStorage.getItem(CONSTANTS.CUSTOMER_SUCCESS)
);
var hasInsights = JSON.parse(localStorage.getItem(CONSTANTS.HAS_INSIGHTS));
var zendeskToken = localStorage.getItem(CONSTANTS.ZENDESK_TOKEN);
var storedDashboardConfig = localStorage.getItem(CONSTANTS.CONFIG_STORAGE);
var onboardToggle = JSON.parse(localStorage.getItem(CONSTANTS.ONBOARD_TOGGLE));
var parsedDashboardConfig = storedDashboardConfig
  ? JSON.parse(storedDashboardConfig)
  : null;
if (window.location.hash) {
  try {
    const hashParams = new URLSearchParams(
      window.location.hash.replace(/^#/, "?")
    );
    token = hashParams.get(CONSTANTS.TOKEN);
    customerSuccess = JSON.parse(hashParams.get(CONSTANTS.CUSTOMER_SUCCESS));
    hasInsights = JSON.parse(hashParams.get(CONSTANTS.HAS_INSIGHTS));
    zendeskToken = hashParams.get(CONSTANTS.ZENDESK_TOKEN);
    localStorage.setItem(CONSTANTS.TOKEN, token);
    localStorage.setItem(CONSTANTS.CUSTOMER_SUCCESS, customerSuccess);
    localStorage.setItem(CONSTANTS.HAS_INSIGHTS, hasInsights);
    localStorage.setItem(CONSTANTS.ZENDESK_TOKEN, zendeskToken);
    hashParams.delete(CONSTANTS.TOKEN);
    hashParams.delete(CONSTANTS.CUSTOMER_SUCCESS);
    hashParams.delete(CONSTANTS.HAS_INSIGHTS);
    hashParams.delete(CONSTANTS.ZENDESK_TOKEN);
    window.location.hash = `#${hashParams.toString()}`;
  } catch (err) {
    token = null;
    customerSuccess = null;
    hasInsights = null;
    zendeskToken = null;
    localStorage.removeItem(CONSTANTS.TOKEN);
    localStorage.removeItem(CONSTANTS.CUSTOMER_SUCCESS);
    localStorage.removeItem(CONSTANTS.HAS_INSIGHTS);
    localStorage.removeItem(CONSTANTS.ZENDESK_TOKEN);
  }
}
var features = localStorage.getItem(CONSTANTS.FEATURES);
var app = require("./Main.elm").Elm.Main.init({
  node: document.getElementById(CONSTANTS.ELM),
  flags: {
    token: token,
    customerSuccess: customerSuccess,
    hasInsights: hasInsights,
    zendeskToken: zendeskToken,
    features: features,
    appSite: process.env.CONSUMER_WEB_URL,
    dashboardConfig: parsedDashboardConfig,
    thumbnailACILearning: new URL(
      "../resources/aci_default_thumbnail.jpg",
      import.meta.url
    ).pathname,
    onboardToggle: onboardToggle,
  },
});

app.ports.newTab.subscribe((url) => window.open(url, "_blank"));

app.ports.openZendesk.subscribe(function () {
  if (typeof zE !== "function") return;
  zE("messenger", "open");
});

app.ports.downloadCsv.subscribe(function (args) {
  var fileName = args[0];
  var csvString = args[1];
  var blob = new Blob([csvString], { type: "text/csv" });
  var url = window.URL.createObjectURL(blob);
  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    var a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  window.URL.revokeObjectURL(url);
});

app.ports.setDashboardConfig.subscribe(function (dashboardConfig) {
  localStorage.setItem(
    CONSTANTS.CONFIG_STORAGE,
    JSON.stringify(dashboardConfig)
  );
});

app.ports.setOnboardToggle.subscribe(function (toggled) {
  localStorage.setItem(CONSTANTS.ONBOARD_TOGGLE, toggled);
});

app.ports.logout.subscribe(function () {
  localStorage.removeItem(CONSTANTS.TOKEN);
  localStorage.removeItem(CONSTANTS.CUSTOMER_SUCCESS);
  localStorage.removeItem(CONSTANTS.HAS_INSIGHTS);
  localStorage.removeItem(CONSTANTS.ZENDESK_TOKEN);
});

app.ports.logoutZendesk.subscribe(function () {
  if (typeof zE === "function") {
    zE("messenger", "logoutUser");
  }
  localStorage.removeItem(CONSTANTS.ZENDESK_TOKEN);
  zendeskToken = null;
});

app.ports.initLottie.subscribe(function () {
  if (lottie) {
    lottie.destroy();
    setTimeout(function () {
      lottie.loadAnimation({
        container: document.getElementById(CONSTANTS.LOTTIE),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../resources/Products.json"),
      });
    }, 2000);
  }
});

var portSends = {
  RECAPTCHA_LOADED: "RECAPTCHA_LOADED",
  RECAPTCHA_TOKEN: "RECAPTCHA_TOKEN",
  RECAPTCHA_EXPIRED: "RECAPTCHA_EXPIRED",
  RECAPTCHA_ERROR: "RECAPTCHA_ERROR",
};

var recaptchaSuccess = function (token) {
  var sendConfig = {};
  sendConfig[portSends.RECAPTCHA_TOKEN] = token;
  app.ports.receive.send(sendConfig);
};
var recaptchaExpired = function () {
  var sendConfig = {};
  sendConfig[portSends.RECAPTCHA_EXPIRED] = portSends.RECAPTCHA_EXPIRED;
  app.ports.receive.send(sendConfig);
};
var recaptchaError = function () {
  var sendConfig = {};
  sendConfig[portSends.RECAPTCHA_ERROR] = portSends.RECAPTCHA_ERROR;
  app.ports.receive.send(sendConfig);
};
var recaptchRenderConfig = {
  sitekey: process.env.RECAPTCHA_INVISIBLE_PUBLIC_KEY,
  badge: "bottomleft",
  callback: recaptchaSuccess,
  "expired-callback": recaptchaExpired,
  "error-callback": recaptchaError,
  size: "invisible",
};
var recaptchaBypass = process.env.RECAPTCHA_BYPASS == "1";

const recaptchaLoaded = () => {
  let sendConfig = {};
  sendConfig[portSends.RECAPTCHA_LOADED] = portSends.RECAPTCHA_LOADED;
  app.ports.receive.send(sendConfig);
};

window.recaptchaLoaded = recaptchaLoaded;

const loadRecaptcha = () => {
  const existingScript = document.getElementById("Recaptcha");

  if (!existingScript) {
    const script = document.createElement("script");
    script.defer = true;
    script.src = `https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit`;
    script.id = "Recaptcha";
    document.body.appendChild(script);
  }
};
loadRecaptcha();

var portSubs = {
  RECAPTCHA_RENDER: "RECAPTCHA_RENDER",
  RECAPTCHA_EXECUTE: "RECAPTCHA_EXECUTE",
  RECAPTCHA_RESET: "RECAPTCHA_RESET",
  GO_TO_EXTERNAL_LINK_NEW_TAB: "GO_TO_EXTERNAL_LINK_NEW_TAB",
  SET_LOGIN_VARIABLES: "SET_LOGIN_VARIABLES",
};
app.ports.call.subscribe(function (portConfig) {
  var UNKNOWN_PORT_MESSAGE = function (location) {
    var logMessage = location + " - Elm port sent unknown message: ";
    console.log(logMessage, portConfig);
  };
  if (
    portConfig.hasOwnProperty(CONSTANTS.MESSAGE_KEY) &&
    typeof portConfig[CONSTANTS.MESSAGE_KEY] == CONSTANTS.STRING_TYPE
  ) {
    switch (portConfig[CONSTANTS.MESSAGE_KEY]) {
      case portSubs.RECAPTCHA_RENDER:
        if (!recaptchaBypass) {
          window.grecaptcha.ready(() => {
            window.grecaptcha.render("recaptcha", recaptchRenderConfig);
          });
        }
        break;
      case portSubs.RECAPTCHA_EXECUTE:
        if (recaptchaBypass) {
          recaptchaSuccess("bypass");
        } else {
          window.grecaptcha.ready(() => {
            window.grecaptcha
              .execute()
              .then(recaptchaSuccess)
              .catch(recaptchaError);
          });
        }
        break;
      case portSubs.RECAPTCHA_RESET:
        if (!recaptchaBypass) window.grecaptcha.reset();
        break;
      case portSubs.SET_LOGIN_VARIABLES:
        localStorage.setItem(CONSTANTS.TOKEN, portConfig.token);
        localStorage.setItem(
          CONSTANTS.CUSTOMER_SUCCESS,
          portConfig.customerSuccess
        );
        localStorage.setItem(CONSTANTS.HAS_INSIGHTS, portConfig.hasInsights);
        localStorage.setItem(CONSTANTS.ZENDESK_TOKEN, portConfig.zendeskToken);
        loginZendesk(portConfig.zendeskToken);
        break;
      default:
        return UNKNOWN_PORT_MESSAGE("Switch Statement");
    }
  } else {
    return UNKNOWN_PORT_MESSAGE("If/Else");
  }
});

// Whenever localStorage changes in another tab, report it if necessary.
window.addEventListener(
  "storage",
  function (event) {
    if (
      event.storageArea === localStorage &&
      event.key === CONSTANTS.CONFIG_STORAGE
    ) {
      app.ports.configUpdate.send(JSON.parse(event.newValue));
    }
    if (
      event.storageArea === localStorage &&
      event.key === CONSTANTS.ONBOARD_TOGGLE
    ) {
      app.ports.onboardToggleUpdate.send(JSON.parse(event.newValue));
    }
  },
  false
);

app.ports.captureException.subscribe((message) => {
  console.error(message);
  Sentry.captureException(new Error(message));
});

const loginZendesk = (mZendeskToken) => {
  /* race condition; token isn't fully set yet in localStorage.
  When user first logs in pass the token from SET_LOGIN_VARIABLES Port
  all other times just get from localStorage */
  const t = mZendeskToken || zendeskToken;
  const s = document.createElement("script");
  s.id = "ze-snippet";
  s.src = `https://static.zdassets.com/ekr/snippet.js?key=${process.env.ZENDESK_KEY}`;
  s.async = true;
  s.onload = () => {
    if (!t) return;
    zE("messenger", "logoutUser");
    zE("messenger", "loginUser", (callback) => callback(t));
  };
  document.head.appendChild(s);
};
loginZendesk(null);
